<template>
  <div>
    <div
      class="item coll2 comWrapper card mt-2 mb-2 p-3"
      v-for="(item, index) in viewData"
      :key="index"
    >
      <div class="comWrapper-wrapper van-hairline--bottom">
        <span style="background: #f44336"></span>
        {{ item[列[0].field] }}
      </div>
      <van-cell-group>
        <template v-for="(col, idx) in 列">
          <van-cell
            v-if="idx > 0 && col.field != 'partyList'"
            :key="'col_' + idx"
            :title="col.title"
            :value="item[col.field]"
          />
          <van-cell
            v-if="idx > 0 && col.field == 'partyList'"
            :key="'col_' + idx"
          >
            <template #title>
              {{ col.title }}
            </template>
            <template #extra>
              <div class="van-cell__value">
                <div
                  v-for="(last, index) in item[col.field]"
                  :key="'last_' + index"
                >
                  <span v-text="last.name" style="margin-right: 2px"></span>
                  <span class="mycs badge badge-warning">{{ rtv[last.roleType] }}</span>
                </div>
              </div>
            </template>
          </van-cell>
        </template>
        <van-button @click="viewDetail(item)" color="#1989fab7" block>查看详情</van-button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {getCourtAnnoCheckDeatail} from '@/apis/company'
import checkMixin from './mixins/check-mixin'
export default {
  name: "courtAnnoCheck",
  components: {},
  mixins: [checkMixin],
  data() {
    return {
      列: [
        { title: "序号", field: "sort" },
        { title: "案号", field: "caseNo" },
        { title: "案由", field: "caseReason" },
        { title: "开庭时间", field: "courtTime" },
        { title: "当事人信息", field: "partyList" },
      ],
      页码: 1,
      每页数据量: 10,
      viewData: [],
      rtv: {
        1: "被告",
        2: "原告",
        3: "第三方人",
      },
    };
  },
  methods: {
    setApi(cb){
      cb(getCourtAnnoCheckDeatail, 'courtAnnoCheckDetail');
    },
    resetData(data, cb){
      data.partyList?.forEach((item,index)=>{
        item.sort = index + 1;
      })
      cb(data);
    },
    pagination() {
      this.viewData = this.data;
    },
  },
  created() {
    this.data.forEach((item) => {
      item.courtTime = this.$utils.DimeFormat(
        item.courtTime,
        "yyyy-mm-dd-hh-mm"
      );
    });
    this.pagination();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
.coll2 .van-cell{
  &::after{
    left: 0;
  }
}
</style>